var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page-right"},[(_vm.homeType === 'info')?_c('Lyric'):_c('Playing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }